import request from 'oc-request';
import Alpine from "alpinejs";

Alpine.data('subnav', () => ({
    navigation: null,

    init() {
      this.navigation = document.getElementById('model-navigation');
    },

    show(model) {
        request.sendData('ModelNavigation::onHover', {
            data: {
                model: model
            },
            update: {
                '@model-navigation/model-navigation' : '#model-navigation'
            },
            success() {
                document.getElementById('model-navigation').style.display = 'block';
            }
        });
    },
    hide() {
        document.getElementById('model-navigation').style.display = 'none';
    }
}));